/**
 * EcomTraffic LP Product Section - JavaScript Controller
 */

class EcomTrafficProduct {
    constructor(sectionId, data) {
        this.sectionId = sectionId;
        this.data = data;
        this.mode = 'bundle';
        this.activeBlockIndex = 0;
        this.activeBlockIndex = 0;
        this.bundleQty = this.data.settings.bundle_quantity || this.data.settings.bundle_qty || 6;
        this.currencySymbol = this.data.settings.currency_symbol || '€';

        // State
        this.bundleSelectedItems = {};
        this.buyOneSelectedIndex = 0;
        this.selectedSize = null;

        // Modal Elements
        this.modal = document.getElementById('et-product-modal-' + sectionId);
        this.modalCloseBtn = document.getElementById('et-modal-close-' + sectionId);
        this.modalWrapper = document.getElementById('et-modal-wrapper-' + sectionId);
        this.modalSwiperContainer = document.getElementById('et-modal-swiper-' + sectionId);
        this.modalSwiper = null;

        // Cache
        this.productMap = {};

        // Cache DOM elements
        this.section = document.getElementById('et-section-' + sectionId);
        if (!this.section) return;

        this.gallery = document.getElementById('et-gallery-' + sectionId);
        this.header = document.getElementById('et-header-' + sectionId);
        this.benefitsList = document.getElementById('et-benefits-' + sectionId);
        this.sizeSelector = document.getElementById('et-size-options-' + sectionId);
        this.bundleList = document.getElementById('et-bundle-list-' + sectionId);
        this.swatches = document.getElementById('et-swatches-' + sectionId);
        this.atcBtn = document.getElementById('et-atc-btn-' + sectionId);
        this.discountNote = document.getElementById('et-discount-note-' + sectionId);
        this.itemsRemaining = document.getElementById('et-items-remaining-' + sectionId);
        this.bundleModeEl = document.getElementById('et-mode-bundle-' + sectionId);
        this.buyOneModeEl = document.getElementById('et-mode-buy-one-' + sectionId);

        this.styleCards = Array.prototype.slice.call(this.section.querySelectorAll('.et-style-card'));
        this.boxOptions = Array.prototype.slice.call(this.section.querySelectorAll('.et-box-option'));

        this.activeBlockIndex = 0;
        this.init();
    }

    init() {
        var self = this;
        // Expose global methods
        window.etSwitchTab = function (mode) { if (self.switchMode) self.switchMode(mode); };
        window.etSelectStyle = function (index) { if (self.selectStyle) self.selectStyle(index); };

        // Initial Render
        this.updateProductMap();
        this.selectStyle(0);

        // Auto-select size if configured
        var autoSize = this.data.settings.preselected_size;
        if (autoSize) {
            this.selectSize(autoSize);
        }

        this.render();

        if (this.atcBtn) {
            this.atcBtn.addEventListener('click', function () { self.handleAddToCart(); });
        }

        // Initialize Qty Label (default mode is bundle)
        var qtyLabel = document.getElementById('et-qty-label-' + this.sectionId);
        if (qtyLabel) {
            qtyLabel.textContent = (this.data.settings.text_bundle_tab_label || 'Koop 3, krijg 3 gratis');
        }

        // Modal Trigger Delegation (Mobile)
        if (this.gallery) {
            this.gallery.addEventListener('click', function (e) {
                console.log('ET: Gallery Click Detected', e.target);
                var target = e.target;

                // Prioritize Video Trigger
                var videoTrigger = target.closest('.et-video-trigger');
                if (videoTrigger) {
                    console.log('ET: Video Trigger Clicked (Delegation)');
                    e.stopPropagation();
                    e.preventDefault();
                    var block = self.getCurrentBlock();
                    console.log('ET: Opening Video Modal with block', block);
                    self.openVideoModal(block);
                    return;
                }

                if (window.innerWidth >= 1024) return;

                // Zoom Modal Trigger (IMG check)
                if (target.tagName === 'IMG' && target.closest('.et-image-item')) {
                    var idx = parseInt(target.dataset.index);
                    if (!isNaN(idx)) {
                        self.openModal(idx);
                    }
                }
            });
        }

        // Swatch Slider Arrow Event

        if (this.swatches) {
            // Swiper Layout - No manual listeners needed
            // Swiper init happens in selectStyle after content render
        }

        // Modal Close Event
        if (this.modalCloseBtn) {
            this.modalCloseBtn.addEventListener('click', function () { self.closeModal(); });
        }

        if (this.modalCloseBtn) {
            this.modalCloseBtn.addEventListener('click', function () { self.closeModal(); });
        }

        // Mobile Zoom Button Trigger
        var zoomBtn = document.getElementById('et-zoom-btn-' + this.sectionId);
        if (zoomBtn) {
            zoomBtn.addEventListener('click', function () {
                // Open modal at index 0 (main image)
                self.openModal(0);
            });
        }

        // Mobile Swiper Progress Logic
        var styleList = this.section.querySelector('.et-style-list');
        var progressBar = this.section.querySelector('.et-style-progress-bar');

        var updateScrollbar = function () {
            var scrollLeft = styleList.scrollLeft;
            var scrollWidth = styleList.scrollWidth - styleList.clientWidth;
            var progress = 0;
            if (scrollWidth > 0) {
                progress = (scrollLeft / scrollWidth) * 100;
            }
            // Clamp between 0 and 100
            progress = Math.max(0, Math.min(100, progress));

            // Use width for filling bar (User preference)
            progressBar.style.width = progress + '%';
            progressBar.style.transform = 'none'; // Clear any transform


            if (styleList.scrollWidth <= styleList.clientWidth) {
                progressBar.parentElement.style.opacity = '0';
            } else {
                progressBar.parentElement.style.opacity = '1';
            }
        };

        if (styleList && progressBar) {
            styleList.addEventListener('scroll', updateScrollbar);
            window.addEventListener('resize', updateScrollbar);
            setTimeout(updateScrollbar, 200);
        }
    }

    updateProductMap() {
        this.productMap = {};
        var block = this.getCurrentBlock();
        if (!block || !block.products) return;
        for (var i = 0; i < block.products.length; i++) {
            this.productMap[String(block.products[i].id)] = block.products[i];
        }
    }

    selectStyle(index) {
        this.activeBlockIndex = index;
        this.bundleSelectedItems = {};
        this.buyOneSelectedIndex = 0;
        this.updateProductMap();

        if (this.styleCards) {
            this.styleCards.forEach(function (card, i) {
                if (i === index) card.classList.add('active');
                else card.classList.remove('active');
            });
        }

        // Toggle Accordion Sets
        var accordionSets = this.section.querySelectorAll('.et-style-accordions');
        console.log('ET: selectStyle', index, 'Found sets:', accordionSets.length);
        accordionSets.forEach(function (set) {
            var idx = parseInt(set.dataset.styleIndex);
            if (idx === index) {
                set.style.display = 'block';
                console.log('ET: Showing set', idx);
            } else {
                set.style.display = 'none';
            }
        });

        // Toggle Size Links
        var sizeLinkSets = this.section.querySelectorAll('.et-style-size-links');
        sizeLinkSets.forEach(function (set) {
            var idx = parseInt(set.dataset.styleIndex);
            if (idx === index) {
                set.style.display = 'flex';
            } else {
                set.style.display = 'none';
            }
        });

        // Trigger resize to wake up 3rd party scripts (like Size Finder)
        window.dispatchEvent(new Event('resize'));

        this.render();
        this.updateSoldOutState();
    }

    switchMode(mode) {
        this.mode = mode;
        if (this.boxOptions) {
            this.boxOptions.forEach(function (box) {
                if (box.dataset.tab === mode) box.classList.add('active');
                else box.classList.remove('active');
            });
        }

        // Update Qty Label
        var qtyLabel = document.getElementById('et-qty-label-' + this.sectionId);
        if (qtyLabel) {
            qtyLabel.textContent = (mode === 'bundle')
                ? (this.data.settings.text_bundle_tab_label || 'Koop 3, krijg 3 gratis')
                : (this.data.settings.text_buy_one_tab_label || 'Koop 1');
        }

        if (this.bundleModeEl) this.bundleModeEl.style.display = mode === 'bundle' ? 'block' : 'none';
        if (this.buyOneModeEl) this.buyOneModeEl.style.display = mode === 'buy-one' ? 'block' : 'none';

        if (mode === 'buy-one') {
            // Swiper handles this internally
            if (this.swatchesSwiper) {
                this.swatchesSwiper.update();
            }
            this.updateSoldOutState(); // Added call here
        }

        this.updateHeader();
        this.updateGallery();

        // Update Video Trigger (Phase 15)
        var block = this.getCurrentBlock();
        this.updateVideoTrigger(block);

        this.updateATC();
    }

    getCurrentBlock() {
        return this.data.blocks[this.activeBlockIndex] || null;
    }

    render() {
        var block = this.getCurrentBlock();
        if (!block) return;
        this.renderBenefits(block);
        this.renderSizes(block);
        this.renderBundleItems(block);
        this.renderSwatches(block);
        this.updateHeader();
        this.updateGallery();
        this.updateATC();
        this.updateSoldOutState(); // Added call here
        this.updateVideoTrigger(block); // Added Phase 15 trigger update
        this.updateDynamicPrices();
    }

    renderBenefits(block) {
        if (!this.benefitsList || !block.benefit_text) return;
        var lines = block.benefit_text.split('\n').filter(function (l) { return l.trim(); });
        this.benefitsList.innerHTML = lines.map(function (line) {
            return '<div class="et-benefit-item"><span class="et-benefit-icon"></span><span class="et-benefit-text">' + line + '</span></div>';
        }).join('<div class="et-benefit-divider"></div>');
    }

    renderSizes(block) {
        if (!this.sizeSelector || !block.products || !block.products[0]) return;
        var product = block.products[0];
        if (!product.variants) return;
        var self = this;
        var scName = 'sc_' + this.sectionId.replace(/-/g, '_');

        var sizes = [];
        var seen = {};
        product.variants.forEach(function (v) {
            var size = v.title.split(' / ')[0];
            if (!seen[size]) {
                seen[size] = true;
                sizes.push(size);
            }
        });

        // Auto-select first size if none selected
        if (!this.selectedSize && sizes.length > 0) {
            this.selectedSize = sizes[0];
        }

        // Update Size Label
        var sizeLabel = document.getElementById('et-selected-size-' + this.sectionId);
        if (sizeLabel && this.selectedSize) {
            sizeLabel.textContent = this.selectedSize;
        }

        this.sizeSelector.innerHTML = sizes.map(function (size) {
            var isActive = self.selectedSize === size ? 'active' : '';
            return '<button type="button" class="et-size-option ' + isActive + '" data-size="' + size + '">' + size + '</button>';
        }).join('');

        // Add event listeners directly
        var opts = this.sizeSelector.querySelectorAll('.et-size-option');
        opts.forEach(function (opt) {
            opt.addEventListener('click', function () {
                self.selectSize(this.dataset.size);
            });
        });
    }

    selectSize(size) {
        this.selectedSize = size;

        // Auto-remove items that are OOS in the new size
        var self = this;

        // Update Label
        var sizeLabel = document.getElementById('et-selected-size-' + this.sectionId);
        if (sizeLabel) sizeLabel.textContent = size;

        // Update active class on size options
        var currentSize = this.selectedSize;
        var sizeOptions = this.section.querySelectorAll('.et-size-option');
        sizeOptions.forEach(function (opt) {
            if (opt.dataset.size === currentSize) opt.classList.add('active');
            else opt.classList.remove('active');
        });

        var productIds = Object.keys(this.bundleSelectedItems);
        productIds.forEach(function (pid) {
            if (self.isSoldOut(pid)) {
                delete self.bundleSelectedItems[pid];
            }
        });

        // We MUST re-render to update the Sold Out states and quantities
        this.render();
        this.updateSoldOutState(); // Added call here
    }

    renderBundleItems(block) {
        if (!this.bundleList || !block.products) return;
        var self = this;
        var scName = 'sc_' + this.sectionId.replace(/-/g, '_');

        this.bundleList.innerHTML = block.products.map(function (product) {
            var productIdStr = String(product.id);
            var qty = self.bundleSelectedItems[productIdStr] || 0;
            var img = (product.metafields && product.metafields.color_image) ? product.metafields.color_image : product.featured_image;
            var isSelected = qty > 0;

            // Check availability for selected size
            var isSoldOut = false;
            if (self.selectedSize) {
                var variant = self.findVariantBySize(product, self.selectedSize, true); // Strict check
                if (!variant || !variant.available) {
                    isSoldOut = true;
                }
            }

            var classes = 'et-bundle-item';
            if (isSelected) classes += ' selected';
            if (isSoldOut) classes += ' sold-out';

            var html = '<div class="' + classes + '" id="et-item-' + self.sectionId + '-' + productIdStr + '" data-product-id="' + productIdStr + '">';
            html += '<div class="et-item-info">';
            html += '<img src="' + img + '" class="et-item-image" alt="' + product.title + '">';
            html += '<div class="et-item-details"><span class="et-item-title">' + product.title + '</span></div>';
            html += '</div>';
            html += '<div class="et-item-action">';

            if (!isSelected) {
                var btnText = isSoldOut ? (self.data.settings.text_sold_out || 'Sold Out') : (self.data.settings.text_add || 'Toevoegen');
                var disabledAttr = isSoldOut ? 'disabled' : '';
                html += '<button class="et-btn-add" type="button" ' + disabledAttr + ' onclick="window[\'' + scName + '\'].addItem(\'' + productIdStr + '\')">' + btnText + '</button>';
            } else {
                html += '<div class="et-quantity-control">';
                html += '<button class="et-qty-btn" type="button" onclick="window[\'' + scName + '\'].updateQty(\'' + productIdStr + '\', -1)"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 5L10.5 5" stroke="#00B67A" stroke-linecap="round"/></svg></button>';
                html += '<span class="et-qty-value">' + qty + '</span>';
                html += '<button class="et-qty-btn" type="button" onclick="window[\'' + scName + '\'].updateQty(\'' + productIdStr + '\', 1)"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0.5V10.5" stroke="#00B67A" stroke-linecap="round"/><path d="M0.5 5.5L10.5 5.5" stroke="#00B67A" stroke-linecap="round"/></svg></button>';
                html += '</div>';
            }

            html += '</div></div>';
            return html;
        }).join('');
    }

    // --- Optimized DOM Update Methods ---

    updateItemUI(productIdStr) {
        var itemEl = document.getElementById('et-item-' + this.sectionId + '-' + productIdStr);
        if (!itemEl) return; // Should not happen

        var qty = this.bundleSelectedItems[productIdStr] || 0;
        var isSelected = qty > 0;
        var scName = 'sc_' + this.sectionId.replace(/-/g, '_');

        // Check if sold out logic needs to be respected (unlikely during qty update, but good for safety)
        var isSoldOut = this.isSoldOut(productIdStr);

        if (isSelected) {
            itemEl.classList.add('selected');
            itemEl.classList.remove('sold-out');
            var actionContainer = itemEl.querySelector('.et-item-action');
            actionContainer.innerHTML =
                '<div class="et-quantity-control">' +
                '<button class="et-qty-btn" type="button" onclick="window[\'' + scName + '\'].updateQty(\'' + productIdStr + '\', -1)"><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 5L10.5 5" stroke="#00B67A" stroke-linecap="round"/></svg></button>' +
                '<span class="et-qty-value">' + qty + '</span>' +
                '<button class="et-qty-btn" type="button" onclick="window[\'' + scName + '\'].updateQty(\'' + productIdStr + '\', 1)"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0.5V10.5" stroke="#00B67A" stroke-linecap="round"/><path d="M0.5 5.5L10.5 5.5" stroke="#00B67A" stroke-linecap="round"/></svg></button>' +
                '</div>';
        } else {
            itemEl.classList.remove('selected');
            if (isSoldOut) itemEl.classList.add('sold-out');

            var actionContainer = itemEl.querySelector('.et-item-action');
            var btnText = isSoldOut ? (this.data.settings.text_sold_out || 'Sold Out') : (this.data.settings.text_add || 'Toevoegen');
            var disabledAttr = isSoldOut ? 'disabled' : '';
            actionContainer.innerHTML =
                '<button class="et-btn-add" type="button" ' + disabledAttr + ' onclick="window[\'' + scName + '\'].addItem(\'' + productIdStr + '\')">' + btnText + '</button>';
        }
    }

    addItem(productId) {
        var productIdStr = String(productId);
        if (this.isSoldOut(productIdStr)) return;

        var total = this.getTotalQty();
        if (total >= this.bundleQty) return;

        this.bundleSelectedItems[productIdStr] = 1;
        this.updateItemUI(productIdStr); // Efficient update
        this.updateATC();
    }

    updateQty(productId, delta) {
        var productIdStr = String(productId);
        var current = this.bundleSelectedItems[productIdStr] || 0;

        if (delta > 0 && this.isSoldOut(productIdStr)) return;

        var total = this.getTotalQty();
        if (delta > 0 && total >= this.bundleQty) return;

        var newQty = Math.max(0, current + delta);
        if (newQty === 0) {
            delete this.bundleSelectedItems[productIdStr];
        } else {
            this.bundleSelectedItems[productIdStr] = newQty;
        }

        this.updateItemUI(productIdStr); // Efficient update
        this.updateATC();
    }

    isSoldOut(productId) {
        if (!this.selectedSize) return false;
        var block = this.getCurrentBlock();
        var product = this.productMap[String(productId)];
        if (!product) return false;

        var variant = this.findVariantBySize(product, this.selectedSize, true);
        return (!variant || !variant.available);
    }

    getTotalQty() {
        var total = 0;
        for (var key in this.bundleSelectedItems) {
            total += this.bundleSelectedItems[key];
        }
        return total;
    }

    renderSwatches(block) {
        if (!this.swatches || !block.products) return;
        var self = this;
        var scName = 'sc_' + this.sectionId.replace(/-/g, '_');

        // 1. Generate Product Slides
        var productSlidesHtml = block.products.map(function (product, i) {
            var img = (product.metafields && product.metafields.color_image) ? product.metafields.color_image : product.featured_image;
            var isActive = i === self.buyOneSelectedIndex ? 'active' : '';
            return '<div class="swiper-slide et-swatch ' + isActive + '" onclick="window[\'' + scName + '\'].selectColor(' + i + ')"><img src="' + img + '" alt="' + product.title + '"></div>';
        }).join('');

        // 2. Generate Empty Filler Slides
        var emptySlidesHtml = '';
        var itemsPerGroup = 5;
        var remainder = block.products.length % itemsPerGroup;
        if (remainder > 0) {
            var needed = itemsPerGroup - remainder;
            for (var j = 0; j < needed; j++) {
                emptySlidesHtml += '<div class="swiper-slide et-swatch et-swatch-empty"></div>';
            }
        }

        this.swatches.innerHTML = productSlidesHtml + emptySlidesHtml;

        // Update Color Label (Initial) & Count
        if (block.products && block.products[this.buyOneSelectedIndex]) {
            var colorLabel = document.getElementById('et-selected-color-' + this.sectionId);
            if (colorLabel) colorLabel.textContent = block.products[this.buyOneSelectedIndex].title;

            // Count Label
            var countLabel = document.getElementById('et-color-count-' + this.sectionId);
            if (countLabel) countLabel.textContent = block.products.length + ' ' + (this.data.settings.text_colors_plural || 'kleuren');
        }

        // Initialize Swiper
        if (this.swatchesSwiper) {
            this.swatchesSwiper.destroy(true, true);
            this.swatchesSwiper = null;
        }

        // Only init if Swiper exists
        if (typeof Swiper !== 'undefined') {
            var swiperContainer = document.getElementById('et-swatches-swiper-' + this.sectionId);
            if (swiperContainer) {
                this.swatchesSwiper = new Swiper(swiperContainer, {
                    slidesPerView: '5',
                    spaceBetween: 12,
                    slidesPerGroup: 5,
                    watchOverflow: true, // Hides navigation if not enough slides
                    navigation: {
                        nextEl: '#et-swatch-next-' + this.sectionId,
                        prevEl: '#et-swatch-prev-' + this.sectionId,
                    },
                    // Prevent checkmark/hover clicks from dragging?
                    simulateTouch: true,
                    grabCursor: true
                });
            }
        } else {
            console.warn('Swiper not loaded yet');
        }
    }

    selectColor(index) {
        this.buyOneSelectedIndex = index;
        // Targeted update for swatches only
        var swatches = this.swatches.querySelectorAll('.et-swatch');
        for (var i = 0; i < swatches.length; i++) {
            if (i === index) swatches[i].classList.add('active');
            else swatches[i].classList.remove('active');
        }

        // Update Color Label
        var block = this.getCurrentBlock();
        if (block && block.products && block.products[index]) {
            var colorLabel = document.getElementById('et-selected-color-' + this.sectionId);
            // Assuming title is "Product Name - Color" or just "Color" depending on user data.
            // Using full title for now or trying to split if hyphenated? 
            // Better to just show title as is, user can adjust data.
            if (colorLabel) colorLabel.textContent = block.products[index].title;
        }

        this.updateGallery();
        this.updateHeader();
        this.updateATC();
        this.updateDynamicPrices(); // Update external price elements
        this.updateVideoTrigger(block); // Phase 15: Ensure video trigger persists
    }

    updateDynamicPrices() {
        var block = this.getCurrentBlock();
        var pricing = this.getPricing(block);
        if (!pricing) return;

        // Just the formatted price for external dynamic elements (e.g. €25,00)
        var rawFormatted = pricing.perPieceBundle.toFixed(2).replace('.', ',');
        var priceOnly = this.currencySymbol + rawFormatted;

        // 1. Update .lp-dynamic__piece elements
        var pieces = document.querySelectorAll('.lp-dynamic__piece');
        pieces.forEach(function (el) {
            el.textContent = priceOnly;
        });
    }

    getPerPieceString(priceValue) {
        var rawFormatted = priceValue.toFixed(2).replace('.', ',');
        // User requested decimals always be shown
        // if (rawFormatted.endsWith(',00')) {
        //     rawFormatted = rawFormatted.replace(',00', '');
        // }
        var formattedPrice = this.currencySymbol + rawFormatted;

        var settingText = this.data.settings.text_per_piece || 'per stuk';

        if (settingText.indexOf('[price]') !== -1) {
            return settingText.replace('[price]', formattedPrice);
        } else {
            // Fallback for legacy "Per Stuk" text -> "Price / Text"
            return formattedPrice + ' / ' + settingText;
        }
    }

    getPricing(block) {
        console.log('ET Debug: getPricing block', block);
        if (!block || !block.products || !block.products[0]) {
            console.log('ET Debug: No products found in block');
            return null;
        }
        var p = block.products[0];
        console.log('ET Debug: First product', p);

        // Base Price (from first variant)
        var basePrice = 0;
        if (p.variants && p.variants[0]) {
            basePrice = p.variants[0].price / 100; // Shopify price is in cents
            console.log('ET Debug: Found variant price', p.variants[0].price, 'Base:', basePrice);
        } else {
            console.log('ET Debug: No variants found for product', p.title);
        }

        var discount = block.discount_percentage || 0;
        var bundleTotalFull = basePrice * this.bundleQty;
        var bundleTotalDiscounted = bundleTotalFull * ((100 - discount) / 100);

        // Per Piece
        var perPieceBundle = bundleTotalDiscounted / this.bundleQty;

        // Single Price (Buy One)
        var singlePrice = basePrice;

        return {
            base: basePrice,
            bundleFull: bundleTotalFull,
            bundleDiscounted: bundleTotalDiscounted,
            single: singlePrice,
            perPieceBundle: perPieceBundle,
            perPieceSingle: singlePrice,
            discount: discount
        };
    }

    updateHeader() {
        var block = this.getCurrentBlock();
        if (!block) return;

        var pricing = this.getPricing(block);
        if (!pricing) return;

        // Elements
        var titleEl = document.getElementById('et-title-' + this.sectionId);
        var reviewWidget = document.getElementById('et-style-review-' + this.sectionId);
        var reviewText = document.getElementById('et-style-review-text-' + this.sectionId);

        if (reviewWidget && reviewText) {
            if (block.review_text) {
                reviewWidget.style.display = 'flex';
                reviewText.textContent = block.review_text;
                reviewWidget.href = block.review_url || '#';
            } else {
                reviewWidget.style.display = 'none';
            }
        }

        // Header Wrapper Toggles
        var headerEl = document.getElementById('et-header-' + this.sectionId);
        var tagWrapper = document.getElementById('et-tag-wrapper-' + this.sectionId);
        var tagText = document.getElementById('et-tag-' + this.sectionId);
        var tagIconDiv = document.getElementById('et-tag-icon-' + this.sectionId);
        var tagSingle = document.getElementById('et-tag-single-' + this.sectionId);

        // Price Elements
        var priceBeforeEl = document.getElementById('et-price-before-' + this.sectionId);
        var priceAfterEl = document.getElementById('et-price-after-' + this.sectionId);
        var priceExtras = document.getElementById('et-price-extras-' + this.sectionId);
        var saveBadge = document.getElementById('et-save-badge-' + this.sectionId);
        var perPiece = document.getElementById('et-per-piece-' + this.sectionId);
        var perPieceWrapper = document.getElementById('et-per-piece-wrapper-' + this.sectionId);

        // Mode Switcher Elements
        var boxTagBundle = document.getElementById('et-box-tag-bundle-' + this.sectionId);
        var boxTagSingle = document.getElementById('et-box-tag-single-' + this.sectionId);
        var boxPriceBundle = document.getElementById('et-box-price-bundle-' + this.sectionId);
        var boxPriceSingle = document.getElementById('et-box-price-single-' + this.sectionId);
        var perPieceBundleEl = document.getElementById('et-box-per-piece-bundle-' + this.sectionId);
        var perPieceSingleEl = document.getElementById('et-box-per-piece-single-' + this.sectionId);

        // Dynamic Icon Injection
        if (tagIconDiv && block.tag_icon_svg) {
            tagIconDiv.innerHTML = block.tag_icon_svg;
        }

        // Update Mode Switcher Prices (Always Visible)
        if (boxPriceBundle) boxPriceBundle.textContent = this.currencySymbol + pricing.bundleDiscounted.toFixed(2).replace('.', ',');
        if (boxPriceSingle) boxPriceSingle.textContent = this.currencySymbol + pricing.single.toFixed(2).replace('.', ',');
        if (boxTagBundle) boxTagBundle.textContent = block.tag_text;
        if (boxTagSingle) boxTagSingle.textContent = block.tag_text_single;

        if (perPieceBundleEl) perPieceBundleEl.textContent = this.getPerPieceString(pricing.perPieceBundle);
        if (perPieceSingleEl) perPieceSingleEl.textContent = this.getPerPieceString(pricing.perPieceSingle);

        // Header Logic
        if (this.mode === 'bundle') {
            // Bundle Layout
            if (headerEl) headerEl.classList.remove('is-single');
            if (headerEl) headerEl.classList.add('is-bundle');

            if (titleEl) titleEl.textContent = block.title_bundle;

            // Show Bundle Tag, Hide Single Tag
            if (tagWrapper) tagWrapper.style.display = 'flex';
            if (tagText) tagText.textContent = block.tag_text;
            if (tagSingle) tagSingle.style.display = 'none';

            // Prices
            // Old Price: Bundle Full (Base * Qty)
            // Override check
            var comparePrice = pricing.bundleFull;
            if (block.bundle_compare_price) {
                comparePrice = parseFloat(block.bundle_compare_price);
            }

            if (priceBeforeEl) {
                // Only show before price if there is a discount or override
                if (pricing.discount > 0 || block.bundle_compare_price) {
                    priceBeforeEl.style.display = 'inline';
                    priceBeforeEl.textContent = this.currencySymbol + comparePrice.toFixed(2).replace('.', ',');
                } else {
                    priceBeforeEl.style.display = 'none';
                }
            }
            if (priceAfterEl) priceAfterEl.textContent = this.currencySymbol + pricing.bundleDiscounted.toFixed(2).replace('.', ',');

            // Show Extras (Save/PerPiece)
            if (priceExtras) priceExtras.style.display = 'flex';
            if (saveBadge) saveBadge.style.display = 'none';

            // Per Piece Text
            if (perPieceWrapper) perPieceWrapper.style.display = 'flex';
            if (perPiece) perPiece.textContent = this.getPerPieceString(pricing.perPieceBundle);

        } else {
            // Single Layout
            if (headerEl) headerEl.classList.remove('is-bundle');
            if (headerEl) headerEl.classList.add('is-single');

            if (titleEl) titleEl.textContent = block.title_buy_one;

            // Hide Bundle Tag, Show Single Tag
            if (tagWrapper) tagWrapper.style.display = 'none';
            if (tagSingle) {
                tagSingle.style.display = 'flex';
                tagSingle.textContent = block.tag_text_single;
            }

            // Prices
            if (priceBeforeEl) priceBeforeEl.style.display = 'none';
            if (priceAfterEl) priceAfterEl.textContent = this.currencySymbol + pricing.single.toFixed(2).replace('.', ',');

            // Hide Extras
            if (priceExtras) priceExtras.style.display = 'none';
        }
    }

    updateGallery() {
        var block = this.getCurrentBlock();
        if (!block || !this.gallery) return;
        var images = [];
        if (this.mode === 'bundle') {
            if (block.products && block.products[0] && block.products[0].images) {
                images = block.products[0].images.slice(0, 4);
            }
        } else {
            var product = block.products[this.buyOneSelectedIndex];
            if (product && product.images) {
                images = product.images.slice(0, 4);
            }
        }

        if (images.length === 0) {
            // Placeholder structure
            var placeholdersLeft = '<div class="et-image-placeholder"></div>'.repeat(3);
            this.gallery.innerHTML =
                '<div class="et-gallery-col-small">' + placeholdersLeft + '</div>' +
                '<div class="et-gallery-col-large"><div class="et-image-wrapper-large"><div class="et-image-placeholder"></div></div></div>';
            return;
        }

        // Layout: Left Col (indices 1,2,3), Right Col (index 0 - Main)
        // Assuming typical Shopify order where [0] is Featured.
        // If fewer than 4 images, we fill available slots.

        var mainImage = images[0];
        var smallImages = images.slice(1);

        var smallHtml = smallImages.map(function (img, i) {
            // Note: small images start at index 1
            var realIndex = i + 1;
            return '<div class="et-image-wrapper-small"><img src="' + img + '" class="et-image-item" data-index="' + realIndex + '" alt="Product Small"></div>';
        }).join('');

        var largeHtml = '<div class="et-image-wrapper-large"><img src="' + mainImage + '" class="et-image-item" data-index="0" alt="Product Large"></div>';

        this.gallery.innerHTML =
            '<div class="et-gallery-col-small">' + smallHtml + '</div>' +
            '<div class="et-gallery-col-large">' + largeHtml + '</div>';
    }

    openModal(startIndex) {
        if (!this.modal || !this.modalWrapper) return;
        var block = this.getCurrentBlock();
        if (!block || !block.products) return;

        // Aggregate Images
        var images = [];
        if (this.mode === 'bundle') {
            // Bundle: All images from First 3 products
            var products = block.products.slice(0, 3);
            products.forEach(function (p) {
                if (p.images) images = images.concat(p.images);
            });
        } else {
            // Buy One: Images from selected product only
            var product = block.products[this.buyOneSelectedIndex];
            if (product && product.images) images = product.images;
        }

        if (images.length === 0) return;

        // Populate Slides
        this.modalWrapper.innerHTML = images.map(function (src) {
            return '<div class="swiper-slide"><img src="' + src + '"></div>';
        }).join('');

        this.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Prevent background scroll

        // Init Swiper
        if (this.modalSwiper) {
            this.modalSwiper.destroy(true, true);
            this.modalSwiper = null;
        }

        if (typeof Swiper !== 'undefined') {
            this.modalSwiper = new Swiper(this.modalSwiperContainer, {
                slidesPerView: 1,
                spaceBetween: 20,
                initialSlide: startIndex || 0,
                pagination: {
                    el: '#et-modal-pagination-' + this.sectionId,
                    type: 'bullets',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '#et-modal-next-' + this.sectionId,
                    prevEl: '#et-modal-prev-' + this.sectionId,
                },
                zoom: true // Enable zoom if module available, but basic swiper works fine for full screen
            });
        }
    }

    /* ========================================
       VIDEO MODAL LOGIC (Phase 15)
       ======================================== */

    updateVideoTrigger(block) {
        // Logic to inject the video trigger button if current style has a video
        // Remove existing trigger first
        var existingFn = this.section.querySelector('.et-video-trigger');
        if (existingFn) existingFn.remove();

        if (!block || !block.video_url) return;

        // Create Trigger
        var trigger = document.createElement('div');
        trigger.className = 'et-video-trigger';
        // Set styles or background image
        trigger.innerHTML =
            '<div class="et-video-trigger-bg" style="background-image: url(' + (block.video_trigger_image || '') + '); height: 100%;">' +
            '<div class="et-video-trigger-overlay" style="opacity: ' + ((block.video_overlay_opacity || 30) / 100) + '"></div>' +
            '<div class="et-video-trigger-icon">' +
            '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M16.875 8.82959C17.7083 9.31071 17.7083 10.5135 16.875 10.9947L1.875 19.6549C1.04167 20.136 -4.20613e-08 19.5346 0 18.5724L7.57103e-07 1.25187C7.99165e-07 0.289615 1.04167 -0.311792 1.875 0.169333L16.875 8.82959Z" fill="white"/>' +
            '</svg>' +
            '</div>' +
            '</div>';

        // Append to large image wrapper
        var largeWrapper = this.gallery.querySelector('.et-image-wrapper-large');
        if (largeWrapper) {
            largeWrapper.style.position = 'relative'; // Ensure absolute pos works
            largeWrapper.appendChild(trigger);

            // Bind Click: HANDLED BY DELEGATION NOW
            /*
            var self = this;
            trigger.addEventListener('click', function (e) {
                console.log('ET: Video Trigger Clicked');
                e.stopPropagation(); // Don't trigger zoom modal
                e.preventDefault();
                self.openVideoModal(block);
            });
            */
        }
    }

    openVideoModal(block) {
        console.log('ET: openVideoModal called', block);
        var modal = document.getElementById('et-video-modal-' + this.sectionId);
        var video = document.getElementById('et-product-video-' + this.sectionId);
        console.log('ET: Modal elements:', modal, video);
        var title = document.getElementById('et-video-title-' + this.sectionId);
        var thumb = document.getElementById('et-video-thumb-' + this.sectionId);
        var backdrop = document.getElementById('et-video-backdrop-' + this.sectionId);

        if (!modal || !video) return;

        // Move modal to body to avoid z-index/transform issues
        document.body.appendChild(modal);

        // Setup Content.src = block.video_url;
        video.src = block.video_url;
        video.poster = block.video_poster || '';
        if (title) title.textContent = block.style_title || ''; // Use style title
        if (thumb && block.video_trigger_image) thumb.src = block.video_trigger_image;

        // Show Modal
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        // Play Video
        video.play().catch(function (e) { console.log('Autoplay blocked', e); });

        // Bind Close Events
        var self = this;
        var closeBtn = document.getElementById('et-video-close-' + this.sectionId);
        if (closeBtn) closeBtn.onclick = function () { self.closeVideoModal(); };
        if (backdrop) backdrop.onclick = function () { self.closeVideoModal(); };

        // Bind Play/Pause
        var userClickArea = document.getElementById('et-video-click-area-' + this.sectionId);
        if (userClickArea) {
            userClickArea.onclick = function () {
                if (video.paused) {
                    video.play();
                    self.setVideoPlayIcon(false);
                } else {
                    video.pause();
                    self.setVideoPlayIcon(true);
                }
            };
        }

        // Progress Update
        video.ontimeupdate = function () {
            var pct = (video.currentTime / video.duration) * 100;
            var bar = document.getElementById('et-video-progress-' + self.sectionId);
            if (bar) bar.style.width = pct + '%';

            // Auto close at end? User didn't specify, but loops usually or stops.
            if (video.ended) {
                self.setVideoPlayIcon(true);
            }
        };
    }

    setVideoPlayIcon(show) {
        var icon = document.getElementById('et-video-play-icon-' + this.sectionId);
        if (icon) icon.style.display = show ? 'flex' : 'none';
    }

    closeVideoModal() {
        var modal = document.getElementById('et-video-modal-' + this.sectionId);
        var video = document.getElementById('et-product-video-' + this.sectionId);

        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (modal) {
            modal.style.display = 'none';
        }
        document.body.style.overflow = '';
    }

    closeModal() {
        if (!this.modal) return;
        this.modal.style.display = 'none';
        document.body.style.overflow = '';
        if (this.modalSwiper) {
            this.modalSwiper.destroy(true, true);
            this.modalSwiper = null;
        }
    }

    updateATC() {
        if (!this.atcBtn) return;
        var total = this.getTotalQty();
        var remaining = this.bundleQty - total;
        var text = '';
        var disabled = true;

        if (this.itemsRemaining) {
            this.itemsRemaining.textContent = remaining > 0 ? remaining + ' ' + (this.data.settings.text_items_remaining_suffix || 'items om te gaan') : (this.data.settings.text_complete || 'Compleet!');
        }

        if (this.mode === 'bundle') {
            if (!this.selectedSize) {
                text = this.data.settings.text_select_size;
                disabled = true;
            } else if (remaining > 0) {
                text = this.data.settings.text_select_more.replace('[qty]', remaining);
                disabled = true;
            } else {
                // Calculate Price: Bundle Discounted
                var pricing = this.getPricing(this.getCurrentBlock());
                var priceStr = pricing ? ' - ' + this.currencySymbol + pricing.bundleDiscounted.toFixed(2).replace('.', ',') : '';
                text = this.data.settings.text_add_to_cart + priceStr;
                disabled = false;
            }
        } else {
            if (!this.selectedSize) {
                text = this.data.settings.text_select_size;
                disabled = true;
            } else {
                // Calculate Price: Single
                var pricing = this.getPricing(this.getCurrentBlock());
                var priceStr = pricing ? ' - ' + this.currencySymbol + pricing.single.toFixed(2).replace('.', ',') : '';
                text = (this.data.settings.text_add_to_cart || 'In winkelwagen') + priceStr;
                disabled = false;
            }
        }
        this.atcBtn.textContent = text;
        this.atcBtn.disabled = disabled;
    }

    handleAddToCart() {
        var self = this;
        var block = this.getCurrentBlock();
        if (!block) return;

        this.atcBtn.disabled = true;
        var originalText = this.atcBtn.textContent;
        this.atcBtn.textContent = this.data.settings.text_adding || 'Adding...';

        var items = [];
        var skippedItems = 0;

        if (this.mode === 'bundle') {
            var productIds = Object.keys(this.bundleSelectedItems);
            for (var idx = 0; idx < productIds.length; idx++) {
                var productIdStr = productIds[idx];
                var qty = this.bundleSelectedItems[productIdStr];

                if (qty > 0) {
                    var foundProduct = this.productMap[productIdStr];

                    if (!foundProduct) continue;

                    var variant = this.findVariantBySize(foundProduct, this.selectedSize, true);
                    if (variant && variant.available) {
                        items.push({ id: variant.id, quantity: qty, properties: { _chrisPack: true } });
                    } else {
                        skippedItems++;
                    }
                }
            }
        } else {
            var product = block.products[this.buyOneSelectedIndex];
            if (product) {
                var variant = this.findVariantBySize(product, this.selectedSize, true);
                if (variant && variant.available) {
                    items.push({ id: variant.id, quantity: 1 });
                } else {
                    skippedItems++;
                    alert(this.data.settings.text_alert_oos || 'Selected item is out of stock.');
                    this.atcBtn.textContent = originalText;
                    this.atcBtn.disabled = false;
                    return;
                }
            }
        }

        if (skippedItems > 0 && this.mode === 'bundle') {
            alert((this.data.settings.text_alert_skipped || 'Some items ([qty]) were out of stock and skipped.').replace('[qty]', skippedItems));
        }

        if (items.length === 0) {
            if (skippedItems === 0) alert(this.data.settings.text_alert_empty || 'No items to add.');
            this.atcBtn.textContent = originalText;
            this.atcBtn.disabled = false;
            return;
        }

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=variant-added', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
            .then(function (response) {
                return response.json().then(function (data) {
                    return { ok: response.ok, data: data };
                });
            })
            .then(function (result) {
                if (result.ok) {
                    console.log('ET: Added to cart', result);
                    // Dispatch specific event for theme drawer
                    document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                        bubbles: true,
                        detail: {
                            items: result.data.items,
                            cart: result.data
                        }
                    }));
                    // Legacy/Standard events fallback
                    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                    document.documentElement.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: result.data }));

                    self.atcBtn.textContent = self.data.settings.text_added || 'Added!';
                    setTimeout(function () { self.updateATC(); }, 2000);
                } else {
                    alert('Error: ' + (result.data.description || result.data.message));
                    self.atcBtn.textContent = originalText;
                    self.atcBtn.disabled = false;
                }
            })
            .catch(function (e) {
                alert(self.data.settings.text_alert_error || 'Network error.');
                self.atcBtn.textContent = originalText;
                self.atcBtn.disabled = false;
            });
    }

    findVariantBySize(product, size, strict) {
        if (!product || !product.variants || product.variants.length === 0) return null;
        if (!size) {
            if (strict) return null;
            for (var i = 0; i < product.variants.length; i++) {
                if (product.variants[i].available) return product.variants[i];
            }
            return product.variants[0];
        }
        for (var j = 0; j < product.variants.length; j++) {
            var parts = product.variants[j].title.split(' / ');
            for (var k = 0; k < parts.length; k++) {
                if (parts[k].trim().toLowerCase() === size.toLowerCase()) {
                    return product.variants[j];
                }
            }
        }

        if (!variant && strict) return null;
        if (!variant) return product.variants[0]; // Fallback? Or better to return null?

        return variant;
    }

    updateSoldOutState() {
        var currentBlock = this.getCurrentBlock();
        if (!currentBlock || !currentBlock.products || !this.swatches) return;

        var self = this;
        var slides = this.swatches.querySelectorAll('.et-swatch:not(.et-swatch-empty)');

        slides.forEach(function (slide, i) {
            // Check availability for current selected size
            var product = currentBlock.products[i];
            if (!product) return;

            // If we are in "Buy One" mode, we care about the specific size availability
            // If in bundle mode, maybe not? User request "soldout state does not exist in the buy one mode"

            var isAvailable = false;
            var variant = self.findVariantBySize(product, self.selectedSize, true);

            if (variant && variant.available) {
                isAvailable = true;
            } else if (!self.selectedSize) {
                // If no size selected, is any variant available?
                isAvailable = product.variants.some(function (v) { return v.available; });
            }

            if (isAvailable) {
                slide.classList.remove('sold-out');
                slide.style.display = ''; // Ensure visible if available
            } else {
                slide.classList.add('sold-out');
                // User requested not to even show them or strictly unselectable
                // If we hide them completely, it might shift layout, but let's try pointer-events:none + opacity
                // Or actually hide them if "not even show"
                // slide.style.display = 'none'; // Uncomment if user strictly wants them gone
            }
        });

        // Disable unavailable size options for current color? 
        // Logic for Size Finder: ensure we pass correct context
        if (window.wair) {
            // Maybe re-init wair if available
        }
    }

    formatMoney(val) {
        // user request: "make it not rounded if it has ,50 for example only when it's ,00"
        // and "no space between the currency and dynamic price"

        // Check if value has decimals
        var hasDecimals = (val % 1 !== 0);

        var options = {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: hasDecimals ? 2 : 0
        };

        // Use en-IE or similar to often get "€15" format, or manually format.
        // nl-NL gives "€ 15". en-US gives "€15.00" (if EUR).
        // Let's try to string manip to be safe for "no space" requirement
        var formatted = new Intl.NumberFormat('nl-NL', options).format(val);

        // Remove spaces (e.g. € 15,50 -> €15,50)
        return formatted.replace(/\s+/g, '');
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (!window.etSectionData) return;
    var keys = Object.keys(window.etSectionData);
    for (var i = 0; i < keys.length; i++) {
        var id = keys[i];
        var scName = 'sc_' + id.replace(/-/g, '_');
        window[scName] = new EcomTrafficProduct(id, window.etSectionData[id]);
    }
});
